import {Banner, Layout, Nav, Typography} from '@douyinfe/semi-ui';
import {DirectoryTree, Logo} from '../App';
import {useEffect, useState} from 'react';
import axios from 'axios';
import {Link, Route, Routes, useNavigate, useParams} from 'react-router-dom';
import {MarkdownRender} from '../libs/MarkdownRender';
import {IconChevronLeft} from '@douyinfe/semi-icons';


function MarkdownContent ( {markdown, filename} ) {
    
    const { Header, Content } = Layout
    const navigate = useNavigate()
    const { Text } = Typography
    
    return (
        <Layout style={{width: '100vw', height: '100vh'}}>
            <Header
                style={{ width: '100%', height: '5%'}}
            >
                <Nav
                    style={{ height: '100%', width: '100%' }}
                    mode={'horizontal'}
                    bodyStyle={{ width: '100%' }}
                    header={<IconChevronLeft onClick={() => navigate('/')} />}
                >
                    <Text ellipsis={{}} style={{ maxWidth: '80%', boxSizing: 'border-box' }}>{filename}</Text>
                </Nav>
            </Header>
            <Content style={{ width: '100%', height: '95%', overflow: 'auto', padding: 10 }}>
                <MarkdownRender markdown={markdown} />
            </Content>
        </Layout>
    )
}


export function MobileApp ( {config} ) {
    const [blogList, setBlogList] = useState([])
    const [selectedKey, setSelectKey] = useState('')
    const [openKeys, setOpenKeys] = useState([])
    const [markdown, setMarkdown] = useState('')
    
    const params = useParams()
    
    useEffect(() => {
        axios.get('config/blog_list.json')
            .then(res => {
                setBlogList(res.data?.children)
                if (params['*']) {
                    const link = `${params['*']}.md`
                    let opens = link.split(/\/|\\/g)
                    opens = opens.slice(0, opens.length - 1)
                    opens = opens.map((_, index, array) => array.slice(0, index + 1).join('\\'))
                    setSelectKey(link)
                    setOpenKeys([...openKeys, ...opens])
                }
            })
    }, [])
    
    useEffect(() => {
        if (selectedKey !== '') {
            axios.get(`blog/${selectedKey}`)
                .then(res => {
                    setMarkdown(res.data)
                })
                .catch(reason => {
                    setMarkdown('- # 博客不存在')
                })
        }
    }, [selectedKey])
    
    const { Header, Content } = Layout
    
    return (
        <Layout
            style={{ height: '100vh', width: '100vw', boxSizing: 'border-box' }}
        >
            <Banner
                type="info"
                description="PC端体验更佳，建议使用PC访问！"
            />
            <Routes>
                <Route path='/' element={
                    <>
                        <Header
                            style={{ height: '30%', width: '100%', boxSizing: 'border-box', padding: 10 }}
                        >
                            {config?.username ? <Logo config={config} /> : <></>}
                        </Header>
                        <Content
                            style={{ height: '70%', width: '100%', boxSizing: 'border-box', padding: 10 }}
                        >
                            <Nav
                                limitIndent={false}
                                style={{ height: '100%', width: '100%', border: 0, borderRight: 0 }}
                                bodyStyle={{maxHeight: '100%', overflow: 'auto'}}
                                renderWrapper={({ itemElement, isSubNav, isInSubNav, props }) => {
                                    if (isSubNav) return itemElement
                                    return <Link to={props.itemKey.replace(/.md/g, '')} style={{ textDecoration: "none" }} > {itemElement} </Link>
                                }}
                                selectedKeys={[selectedKey]}
                                openKeys={openKeys}
                                onSelect={data => {
                                    setSelectKey(data.itemKey)
                                }}
                                onOpenChange={item => setOpenKeys(item.openKeys)}
                            >
                                {
                                    blogList.map( item => <DirectoryTree data={item} index={0} tooltips='left' />)
                                }
                            </Nav>
                        </Content>
                    </>
                } />
                <Route path={'/*'} element={ <MarkdownContent markdown={markdown} filename={selectedKey} /> } />
            </Routes>
        </Layout>
    )
    
}